import React from 'react';

const AnimatedLogo = ({ height = '135px' }) => {
    return (
        <div style={{ position: 'relative', height, display: 'inline-block' }}>
            <img
                src="/expertise_hb_logo_blanco_web.png"
                alt="Expertise HB Logo"
                style={{ height: '100%', width: 'auto', display: 'block', objectFit: 'contain' }}
            />

            <svg
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }}
                viewBox="0 0 1000 500"
            >
                <defs>
                    {/* Filtro de resplandor (Glow) para las estrellas */}
                    <filter id="starGlow" x="-50%" y="-50%" width="200%" height="200%">
                        <feGaussianBlur stdDeviation="4" result="blur" />
                        <feMerge>
                            <feMergeNode in="blur" />
                            <feMergeNode in="blur" />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>

                    {/* Forma de la estrella */}
                    <polygon
                        id="star"
                        points="0,-8 2,-2 8,0 2,2 0,8 -2,2 -8,0 -2,-2"
                        fill="#f2ca50"
                        filter="url(#starGlow)"
                    />

                    {/* Ruta del contorno del coche */}
                    <path
                        id="carPath"
                        d="M200 300
                           Q300 220 500 220
                           Q700 220 800 300
                           Q820 330 750 350
                           Q600 370 400 370
                           Q250 360 200 300 Z"
                    />

                    {/* Ruta del escudo */}
                    <path
                        id="shieldPath"
                        d="M480 140
                           L560 170
                           L540 250
                           L500 280
                           L460 250
                           L440 170 Z"
                    />
                </defs>

                {/* Trazos tenues y fijos de fondo (opcional) */}
                <use href="#carPath" stroke="#f2ca50" strokeWidth="2" strokeDasharray="4 8" opacity="0.3" fill="none" />
                <use href="#shieldPath" stroke="#f2ca50" strokeWidth="2" strokeDasharray="4 8" opacity="0.3" fill="none" />

                {/* ====== Estrellas moviéndose en el coche ====== */}
                {/* Estrella 1 */}
                <use href="#star">
                    <animateMotion dur="4s" repeatCount="indefinite">
                        <mpath href="#carPath" />
                    </animateMotion>
                </use>

                {/* Estrella 2 (comienza más tarde) */}
                <use href="#star">
                    <animateMotion dur="4s" begin="2s" repeatCount="indefinite">
                        <mpath href="#carPath" />
                    </animateMotion>
                    {/* Animación parpadeante */}
                    <animate attributeName="opacity" values="0.2;1;0.2" dur="1s" repeatCount="indefinite" />
                </use>

                {/* ====== Estrellas moviéndose en el escudo ====== */}
                {/* Estrella 3 */}
                <use href="#star">
                    <animateMotion dur="3s" repeatCount="indefinite">
                        <mpath href="#shieldPath" />
                    </animateMotion>
                    {/* Escala variable */}
                    <animateTransform attributeName="transform" type="scale" values="0.5;1.5;0.5" dur="1.5s" repeatCount="indefinite" />
                </use>

                {/* Estrella 4 (retrasada) */}
                <use href="#star">
                    <animateMotion dur="3s" begin="1.5s" repeatCount="indefinite">
                        <mpath href="#shieldPath" />
                    </animateMotion>
                </use>

            </svg>
        </div>
    );
};

export default AnimatedLogo;
